// ¿De dónde llegó cada cuenta nueva de Kontrol? (sql/141)
// Los enlaces de los perfiles, la web y los anuncios traen ?o=<origen>
// (instagram, facebook, tiktok, youtube, web-hero, anuncio-oferta…). Se recuerda
// 30 días en este dispositivo, por si la persona vuelve otro día a crear la
// cuenta, y se manda en el registro (AuthContext.registrarse).
import { normalizarOrigen, detectarOrigen } from './origenCatalogo';

const CLAVE = 'kontrol-origen-registro';
const VIGENCIA = 30 * 24 * 60 * 60 * 1000;

function guardado(ahora = Date.now()) {
  try {
    const g = JSON.parse(localStorage.getItem(CLAVE) || 'null');
    return g && ahora - Number(g.en) < VIGENCIA ? normalizarOrigen(g.o) : null;
  } catch {
    return null;
  }
}

// Sin etiqueta: la app que lo abrió, o la web de Automatika si vino de ahí.
function detectado() {
  try {
    const ref = document.referrer ? new URL(document.referrer).hostname : '';
    if (/(^|\.)automatikaia\.com$/i.test(ref) && ref !== window.location.hostname) return 'web';
  } catch { /* referrer raro */ }
  return detectarOrigen();
}

// Al abrir la app sin sesión: la etiqueta del enlace manda (la última gana);
// lo detectado solo se guarda si no había nada.
export function capturarOrigenRegistro() {
  try {
    const p = new URLSearchParams(window.location.search);
    const o = normalizarOrigen(p.get('o') || p.get('utm_source'));
    if (o) localStorage.setItem(CLAVE, JSON.stringify({ o, en: Date.now() }));
    else if (!guardado()) {
      const d = detectado();
      if (d) localStorage.setItem(CLAVE, JSON.stringify({ o: d, en: Date.now() }));
    }
  } catch { /* sin almacenamiento: se toma de la URL al registrarse */ }
}

export function origenRegistro() {
  try {
    const p = new URLSearchParams(window.location.search);
    return normalizarOrigen(p.get('o') || p.get('utm_source')) || guardado() || detectado();
  } catch {
    return null;
  }
}

// Nombres para "Números de Kontrol".
const NOMBRES = {
  instagram: '📸 Instagram', facebook: '👍 Facebook', tiktok: '🎵 TikTok', youtube: '▶️ YouTube',
  whatsapp: '💬 WhatsApp', google: '🔎 Google', web: '🌐 Web automatikaia.com', sin_etiqueta: '❔ Sin etiqueta',
};
export function nombreOrigenRegistro(o) {
  if (NOMBRES[o]) return NOMBRES[o];
  if (/^web-/.test(o)) return `🌐 Web · ${o.slice(4)}`;
  if (/^anuncio-/.test(o)) return `📣 Página de anuncios · ${o.slice(8)}`;
  return `🏷️ ${o}`;
}
